// F-COMMENTS — plug the real Comments pane into the F-SHELL registry seam.
//
// Same seam proof as F-SOURCES / F-VERSIONS (plan §2.1): the feature
// self-registers via this `register.ts`, the barrel `features/index.ts`
// imports it as a side-effect, and the shell renders the Pane — with ZERO edit
// to any shared shell file. The acceptance gate is an EMPTY
// `git diff main -- src/ui/shell/`.
//
// `labelKey` REUSES the F-SHELL key `shell.tab.comments` (does not duplicate
// it); `order: 40` matches the FROZEN `KNOWN_TABS` slot (comments=40).
//
// No `badge` selector: the open-thread count is not held in any store — it
// would require a fetch, and `TabDef.badge` is a synchronous store selector
// (the registry forbids I/O in a selector). So the badge is intentionally
// OMITTED rather than faked.

import { createElement } from 'react'
import { registerTab } from '@/ui/shell/tab-registry'
import { CommentsPane } from './CommentsPane'

registerTab({
  id: 'comments',
  order: 40,
  labelKey: 'shell.tab.comments',
  // Neutral speech-bubble glyph (RTL-agnostic — not a direction-implying icon,
  // so no scaleX flip needed per CLAUDE.md §9.2 rule 3).
  icon: createElement('span', { 'aria-hidden': true }, '💬'),
  Pane: CommentsPane,
})
